import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthVerifier from './AuthVerifier';

/**
 * AuthWrapper component for nested routes
 * Checks if user is authenticated and either renders children or redirects to login
 */
const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const { token, user } = useSelector(state => state.auth || {});
  const isAuthenticated = Boolean(token && user?.id);
  
  if (!isAuthenticated) {
    // Redirect to login page with a return path
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  
  return (
    <>
      <AuthVerifier />
      {children}
    </>
  );
};

export default AuthWrapper; 